import React from "react";
import cx from "clsx";
import styles from "../scss/OneClickCancellation.module.scss";
import { Button } from "../../../../../../shared/Button/Button";
import { usePermission } from "../../../../../../hooks/usePermission";
import { PERMISSIONS } from "../../../../../../consts/api";

const OneClickCancellationSelectedClinics = ({
  setShowModal,
  activeClinics,
}) => {
  const { permitted } = usePermission(PERMISSIONS.settings.walletSettings);

  return (
    <div
      className={cx(
        styles.selectedClinicsContainer,
        activeClinics?.length === 0 && styles.noBorder,
      )}
    >
      {activeClinics?.length > 0 ? (
        <div className={styles.clinicsListContainer}>
          {activeClinics.map((clinic) => (
            <span key={clinic.value} className={styles.clinicName}>
              {clinic.label}
            </span>
          ))}
        </div>
      ) : (
        <span>No Clinics Selected</span>
      )}

      {permitted && (
        <Button
          variant="text"
          onClick={() => setShowModal(true)}
          className={styles.editButton}
        >
          <i className="fa fa-pencil-alt m-r-5" />
          <span>Edit</span>
        </Button>
      )}
    </div>
  );
};

export default OneClickCancellationSelectedClinics;
